import Overlay from "../../Componentes/Overlay";
import SidebarMenu from "../../Componentes/SideMenu";
import SideMenuBtn from "../../Componentes/SideMenuBtn";
import { useModal } from "../../contexts/ModalContext";
import { MODAL_ID as MODAL_GERENCIAR_GRUPOS_ID } from "./ModalGerenciarGrupos";
import { MODAL_ID as MODAL_NOVO_GRUPO_ID } from "./ModalNovoGrupo";

const SidebarGestaoAcessosV2 = () => {
    const { closeModal, openModal } = useModal();

    const handleGerenciarGrupos = () => {
        closeModal();
        openModal(MODAL_GERENCIAR_GRUPOS_ID);
    };

    const handleNovoGrupo = () => {
        closeModal();
        openModal(MODAL_NOVO_GRUPO_ID);
    };

    return (
        <Overlay state={true} changeContent={closeModal}>
            <SidebarMenu>
                <SideMenuBtn button="NOVO GRUPO" clickFunc={handleNovoGrupo} />
                <SideMenuBtn button="GERENCIAR GRUPOS" clickFunc={handleGerenciarGrupos} />
            </SidebarMenu>
        </Overlay>
    );
};

export default SidebarGestaoAcessosV2;
